// extracted by mini-css-extract-plugin
module.exports = {"btn":"VideoButton_btn__2NAGy"};